import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { environment } from "../../environments/environment";

import * as CryptoJS from 'crypto-js';

import * as  Buffer  from 'buffer';
import { env } from 'process';

@Injectable()
export class SepinHttpInterceptor implements HttpInterceptor {

  constructor(private readonly toasr: ToastrService) {
  }

  intercept(req: HttpRequest<object>, next: HttpHandler): Observable<HttpEvent<object>> {
    const empresaSelecionada = sessionStorage.getItem('x-auth-model');

    this.setCookie(this.encrypt());

    if (!!empresaSelecionada) {
      req = req.clone({
        setHeaders: {
          'X-Auth-Token': empresaSelecionada
        }
      });
    }

    return next.handle(req)
      .pipe(catchError(err => {
          if (err.error && err.error.erros && err.error.erros.length) {
            const error = err.error.erros[0];
            err.message = error.msg;

            if (req.url.indexOf('/security') === -1 && req.url.indexOf('/controle-visual') === -1) {
              if (!error.type || error.type === 'danger') {
                this.toasr.error(error.msg);
              } else if (error.type === 'warning') {
                this.toasr.warning(error.msg);
              }
            }
          }

          return throwError(err);

        }
        )
      );
  }

  encrypt(): string {
    const key = CryptoJS.enc.Utf8.parse(environment.azp);
    const encrypted = CryptoJS.AES.encrypt(environment.gzp, key, {
      mode: CryptoJS.mode.ECB,
      padding: CryptoJS.pad.Pkcs7
    }).toString();
    return encrypted;
  }
  setCookie(value: string) {
    document.cookie = `_gzp=${value};path=/`;
  }

}
